module.exports = __webpack_public_path__ + "static/StructuringMLProjects-ecd00a0aa7a8e31cde50050aaeca1a5c.jpg";